
import React from "react";
import { useHistory } from "react-router-dom";
import { auth } from "/Users/michaeltucker/Documents/coding-projects/client/src/firebase.js";

// reactstrap components
import { Button, Container } from "reactstrap";

function Logout() {
  React.useEffect(() => {
    document.body.classList.add("logout-page");
    return () => document.body.classList.remove("logout-page");
  }, []); // ← run once

  const history = useHistory();

  const handleLogout = async () => {
    try {
      await auth.signOut();
    } finally {
      history.push("/");
    }
  };

  return (
    <div className="logout-page">
      <Container className="text-center" style={{ paddingTop: "40px" }}>
        <Button color="warning" className="btn-round" onClick={handleLogout}>
          Log out
        </Button>
      </Container>
    </div>
  );
}

export default Logout;
